/**
 * Retries of the current step, as marks rather than a sentence.
 *
 * "2 attempts" in a metadata line is a fact you have to read; two marks beside
 * a title is a fact you can see, and the difference matters in a list you are
 * scanning for the worst row. Capped at five, because past that the count is
 * the point and the shape stops carrying it.
 *
 * The numeral is printed alongside, not instead. FR-011 requires the row to
 * show *how many times* the step has been attempted, and four marks are a
 * shape a reader recognises rather than a number they can read off — at five
 * nobody counts them. The marks catch the eye; the figure answers it.
 *
 * Nothing below two. A count on every row is wallpaper, and trains the eye to
 * skip the strip where the real signals are.
 */
const MAX_PIPS = 5;

export function Attempts({ count }: { count: number }) {
  if (count < 2) return null;

  return (
    <span
      // The marks are decoration for a value the label already carries, so they
      // are hidden and the whole thing is announced as one phrase.
      title={`${String(count)} attempts`}
      aria-label={`${String(count)} attempts`}
      role="img"
      className="flex shrink-0 items-center gap-0.5"
    >
      {Array.from({ length: Math.min(count, MAX_PIPS) }, (_, index) => (
        <span
          key={index}
          aria-hidden="true"
          className="bg-board-state-failed/45 h-2 w-[3px] rounded-[1px]"
        />
      ))}
      <span
        aria-hidden="true"
        className="text-muted-foreground ms-0.5 text-xs tabular-nums"
      >
        {count}
      </span>
    </span>
  );
}
